import React, { forwardRef } from "react";
import styles from './button.module.scss';

interface ButtonProps {
  type?: 'primary' | 'outline' | 'current' | 'withIcon';
  onClick?: () => void;
  children?: React.ReactNode;
  id?: string;
  isActive?: boolean;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ disabled, type = 'primary', onClick, children, isActive = false, id, className, style }, ref) => {
  const buttonClass = `${styles[type]} ${(type === 'current' && isActive) ? styles.active : ''} ${className || ''}`;

  return (
      <button className={buttonClass} onClick={onClick} id={id} style={style} disabled={disabled} ref={ref}>
        {children}
      </button>
  );
});

export default Button;
